export const workspaceActionTypes = {
    // INIT — triggered after login / session check
    WORKSPACE_INIT_REQUEST: 'W1',
    WORKSPACE_INIT_SUCCESS: 'W2',
    WORKSPACE_INIT_FAILURE: 'W3',

    // SWITCH active workspace
    WORKSPACE_SWITCH_REQUEST: 'W4',
    WORKSPACE_SWITCH_SUCCESS: 'W5',

    // FETCH TEAMS for current workspace
    WORKSPACE_FETCH_TEAMS_REQUEST: 'W6',
    WORKSPACE_FETCH_TEAMS_SUCCESS: 'W7',
    WORKSPACE_FETCH_TEAMS_FAILURE: 'W8',

    // FETCH MEMBERS for current workspace
    WORKSPACE_FETCH_MEMBERS_REQUEST: 'W9',
    WORKSPACE_FETCH_MEMBERS_SUCCESS: 'W10',
    WORKSPACE_FETCH_MEMBERS_FAILURE: 'W11',

    // RESET — on sign out
    WORKSPACE_RESET: 'W12',
};
